import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  site_name: "PilotYatra",
  tagline: "Your Journey to the Cockpit",
  logo_url: "/pilotyatra-logo.jpg",
  favicon_url: "/pilotyatra-logo.jpg",
  academy_name: "PilotYatra Aviation Academy",
  address_line1: "",
  city: "",
  state: "",
  country: "India",
  phone_primary: "",
  whatsapp: "",
  email: "contact@pilotyatra.com",
  support_email: "support@pilotyatra.com",
  business_hours: "Mon – Sat, 9:00 AM – 7:00 PM IST",
  google_maps_url: "",
  instagram_url: "",
  facebook_url: "",
  youtube_url: "",
  twitter_url: "",
  linkedin_url: "",
  footer_about: "",
  hero_title: "",
  hero_subtitle: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings({ ...FALLBACK, ...data });
    } catch {
      setSettings(FALLBACK);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Apply favicon dynamically
  useEffect(() => {
    if (!settings?.favicon_url) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = settings.favicon_url;
    document.title = "PilotYatra | DGCA Aviation Exam Preparation";
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || { settings: FALLBACK, refresh: () => {}, loaded: true };
}
